import { Text } from '@mantine/core';
import { CampusCasesListView } from './Components/CampusCasesListView';
import { useCampusParam } from '@/hooks/useCampusParam';

export default function CampusCasePage() {
  const { campus, campusLabel, allowed } = useCampusParam();

  if (!allowed) {
    // swap for your existing access-denied panel
    return <Text c="red" p="xl">You do not have access to {campusLabel} cases.</Text>;
  }

  return (
    <CampusCasesListView
      key={campus}
      campus={campus}
      title={`${campusLabel} Cases`}
      subtitle="View care support cases for your campus."
    />
  );
}
